import CUSTOMER_ROUTES from "./CUSTOMER_ROUTES";
import PUBLIC_ROUTES from "./PUBLIC_ROUTES";
import COMPANY_ROUTES from "./COMPANY_ROUTES";
import ADMIN_ROUTES from "./ADMIN_ROUTES";
import { SUBSCRIPTION_INVOICE_ROUTES } from "./SUBSCRIPTION_INVOICE_ROUTES";

const ROUTES = {
  ...ADMIN_ROUTES,
  ...COMPANY_ROUTES,
  ...CUSTOMER_ROUTES,
  ...PUBLIC_ROUTES,
  ...SUBSCRIPTION_INVOICE_ROUTES,
};

export default ROUTES;
